import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "./auth/baseQueryWithReauth";

export const apiSlice = createApi({
  baseQuery: baseQueryWithReauth,
  // TIP-609/610 — an order (TIP-611) invalidates all three: the card must not
  // survive the brief it just spent, and the new row has to appear in the list.
  tagTypes: ["User", "BriefsAllowance", "BriefsList", "BriefDetail"],
  endpoints: (builder) => ({}),
});
